import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from "./UserContext";
import { BrowserRouter } from "react-router-dom";
import { EnquiryProvider } from "./context/EnquiryContext";
import "react-phone-number-input/style.css";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <EnquiryProvider>
        <App />
        </EnquiryProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
